import create from 'zustand'

const useStore = create(set => ({
    bears: 0,
    category: '',
    sub_category: '',
    increasePopulation: (params) => set(state => ({bears: state.bears + params})),
    getSubCategory: (paramCategory, paramSubCategory) => set({category: paramCategory,sub_category: paramSubCategory}),
}))

export default useStore